import { getResolvedPathAndParameters, isContentfulString } from '@philips-internal/oswald-ui-utils';
import { DEFAULT_HTTP_HEADERS, HttpStatus } from './http-service-constants.js';
import { mapRequestBody, mapRequestHeaders } from './mappers/http-service-request-mappers.js';
import { mapResponseBody } from './mappers/http-service-response-mappers.js';
const redirectStatuses = [
    HttpStatus.MOVED_PERMANENTLY,
    HttpStatus.FOUND,
    HttpStatus.SEE_OTHER,
    HttpStatus.TEMPORARY_REDIRECT,
    HttpStatus.PERMANENT_REDIRECT,
];
class HttpError extends Error {
}
function httpError(message) {
    return new Error(`[Http Service]: ${message}`);
}
function verifyResponseStatus(response) {
    if (response.ok) {
        return response;
    }
    const error = new HttpError(response.statusText);
    error.response = response;
    throw error;
}
function isResponseStatusUnauthorized(response) {
    return response.status === HttpStatus.UNAUTHORIZED;
}
function createURL(endpoint, context) {
    let url = endpoint;
    const shouldAddContextToUrl = url.startsWith('/') && (context && !url.startsWith(context));
    if (shouldAddContextToUrl) {
        url = `${context}/${url}`;
    }
    const finalURL = new URL(url, window.location.origin);
    finalURL.pathname = finalURL.pathname.replaceAll(/(\/)+/g, '/');
    return finalURL;
}
function resolveEndpointURL(endpoint, parameters, basePath) {
    if (!isContentfulString(endpoint)) {
        throw new Error('Endpoint is not defined');
    }
    const { queryParams, resolvedPath: resolvedEndpoint } = getResolvedPathAndParameters(endpoint, parameters);
    const url = createURL(resolvedEndpoint, basePath);
    const searchParams = url.searchParams;
    Object.entries(queryParams).forEach(([key, value]) => (Array.isArray(value)
        ? value.forEach(item => searchParams.append(key, item))
        : searchParams.append(key, String(value))));
    return url;
}
function createHttpRequestParameters(method, endpoint, endpointParameters, options) {
    return {
        abortController: options?.abortController,
        body: options?.body,
        endpoint,
        endpointParameters,
        headers: options?.headers,
        method,
    };
}
function createRequest(method, url, headers, abortController, body) {
    const mappedBody = mapRequestBody(body);
    const mappedHeader = mapRequestHeaders({ body: mappedBody, headers: { ...DEFAULT_HTTP_HEADERS, ...headers } });
    return new Request(url.toString(), {
        body: mappedBody,
        headers: mappedHeader,
        method,
        signal: abortController?.signal,
    });
}
const getMappedResponse = (response) => {
    const requestResponse = {
        headers: response.headers,
        ok: response.ok,
        status: response.status,
        statusText: response.statusText,
    };
    if (response.status === HttpStatus.NO_CONTENT) {
        return Promise.resolve(requestResponse);
    }
    return mapResponseBody(response)
        .then((body) => {
        const isRedirected = response.redirected ?? redirectStatuses.find(status => requestResponse.status == status);
        requestResponse.body = body;
        return requestResponse.ok || isRedirected
            ? Promise.resolve(requestResponse)
            : Promise.reject(requestResponse);
    });
};
export { createRequest, createHttpRequestParameters, createURL, getMappedResponse, httpError, HttpError, isResponseStatusUnauthorized, mapRequestBody, resolveEndpointURL, verifyResponseStatus, };
//# sourceMappingURL=http-service-utils.js.map